import React, { useMemo } from "react";
import PropTypes from "prop-types";

const DropdownField = ({
  id,
  name,
  value,
  onChange,
  options,
  placeholder,
  disabled = false,
  className = "",
}) => {
  const selectedOption = useMemo(() => {
    return options.find((option) => String(option.value) === String(value));
  }, [options, value]);

  return (
    <div className="relative w-full">
      <select
        id={id}
        name={name}
        disabled={disabled}
        value={value ?? ""}
        onChange={onChange}
        className={`w-full h-[2.75rem] px-4 pr-12 border border-[#C9D3E0] rounded-xl bg-gradient-to-b from-white to-[#F7FAFF] text-left text-[#0F172A] font-medium tracking-[0.01em] shadow-[0_4px_14px_rgba(15,23,42,0.08)] outline-none ring-0 transition-all duration-200 hover:border-[#93B4DE] hover:shadow-[0_8px_20px_rgba(37,99,235,0.14)] focus:outline-none focus:ring-0 focus-visible:ring-0 disabled:bg-[#F3F4F6] disabled:text-[#9CA3AF] disabled:border-[#E5E7EB] disabled:shadow-none disabled:cursor-not-allowed appearance-none ${className}`}
      >
        <option value="" className="text-[#64748B]">
          {placeholder || "Select option"}
        </option>
        {options.length === 0 ? (
          <option value="" disabled>
            No options found
          </option>
        ) : (
          options.map((option) => (
            <option key={String(option.value)} value={option.value}>
              {option.label}
            </option>
          ))
        )}
      </select>
      <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#E8F0FF] text-[#1D4ED8] border border-[#D3E3FF]">
          <svg
            className="h-4 w-4"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          </svg>
        </span>
      </span>
    </div>
  );
};

DropdownField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default DropdownField;
